/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */

import React from 'react';
import { useLoadGoogleMaps } from './useLoadGoogleMaps';
import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

interface Props {
  children: React.ReactNode;
}

export const GoogleMapsLoader = ({ children }: Props): JSX.Element => {
  const { t } = useTranslation(['googleMap']);

  const loaded = useLoadGoogleMaps();

  if (!loaded) return <Box>{t('googleMap:loadingGoogleMaps')}</Box>;

  return <>{children}</>;
};
